var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("客户管理")]),
              ]),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("健驰客户导入")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "nav" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _vm.parArray.indexOf("wfpCode") != -1
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "未分配客户", name: "2" } },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "label" }, slot: "label" },
                        [
                          _vm.$store.getters.orderCount &&
                          _vm.$store.getters.orderCount.wechatUnassignedNum
                            ? _c(
                                "el-badge",
                                {
                                  attrs: {
                                    value:
                                      _vm.$store.getters.orderCount
                                        .wechatUnassignedNum,
                                  },
                                },
                                [_vm._v(" 未分配客户 ")]
                              )
                            : _c("span", [_vm._v("未分配客户")]),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.parArray.indexOf("fpsbCode") != -1
                ? _c("el-tab-pane", { attrs: { label: "分配失败", name: "3" } })
                : _vm._e(),
              _c("el-tab-pane", { attrs: { label: "分配成功", name: "1" } }),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.show3,
                expression: "!show3",
              },
            ],
            staticClass: "inquiry",
          },
          [
            _c("div", { staticClass: "header" }, [
              _c("span", [_vm._v("查询数据")]),
              _c(
                "p",
                {
                  on: {
                    click: function ($event) {
                      _vm.show3 = true
                    },
                  },
                },
                [_vm._v("收起")]
              ),
            ]),
            _c(
              "el-form",
              {
                ref: "form",
                attrs: {
                  inline: true,
                  model: _vm.queryForm,
                  "label-width": "",
                  size: "mini",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "资源信息" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入客户手机号码/姓名" },
                      model: {
                        value: _vm.queryForm.info,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "info", $$v)
                        },
                        expression: "queryForm.info",
                      },
                    }),
                  ],
                  1
                ),
                _vm.salesAuthorityId != "1"
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "平台名称" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "平台名称",
                              clearable: "",
                              "default-first-option": "",
                              filterable: "",
                            },
                            model: {
                              value: _vm.queryForm.sourceFrom,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "sourceFrom", $$v)
                              },
                              expression: "queryForm.sourceFrom",
                            },
                          },
                          _vm._l(_vm.channeSel, function (items) {
                            return items.dictId != "comm"
                              ? _c("el-option", {
                                  key: items.dictId,
                                  attrs: {
                                    label: items.dictName,
                                    value: items.dictName,
                                  },
                                })
                              : _vm._e()
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("div", { staticClass: "selectDate" }, [
                  _c("span", [_vm._v("资源时间")]),
                  _c(
                    "div",
                    { staticClass: "picker" },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "unlink-panels": "",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          format: "yyyy- MM- dd",
                          "value-format": "yyyy-MM-dd",
                        },
                        on: { input: _vm.immediUpdate },
                        model: {
                          value: _vm.date,
                          callback: function ($$v) {
                            _vm.date = $$v
                          },
                          expression: "date",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm.activeName !== "2"
                  ? _c("div", { staticClass: "selectDate" }, [
                      _c("span", [_vm._v("分配时间")]),
                      _c(
                        "div",
                        { staticClass: "picker" },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "daterange",
                              "unlink-panels": "",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                              format: "yyyy- MM- dd",
                              "value-format": "yyyy-MM-dd",
                            },
                            model: {
                              value: _vm.assigedate,
                              callback: function ($$v) {
                                _vm.assigedate = $$v
                              },
                              expression: "assigedate",
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _c(
                  "el-form-item",
                  { attrs: { label: "客服" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          clearable: "",
                          placeholder: "选择客服",
                          filterable: "",
                          "default-first-option": "",
                        },
                        model: {
                          value: _vm.queryForm.assignorId,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm, "assignorId", $$v)
                          },
                          expression: "queryForm.assignorId",
                        },
                      },
                      _vm._l(_vm.customer, function (items) {
                        return _c("el-option", {
                          key: items.id,
                          attrs: { label: items.reallyName, value: items.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "部门选择" } },
                  [
                    _c("el-cascader", {
                      attrs: {
                        options: _vm.options,
                        props: {
                          checkStrictly: true,
                          label: "orgName",
                          value: "orgCode",
                          children: "children",
                        },
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.queryForm.orgName,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryForm, "orgName", $$v)
                        },
                        expression: "queryForm.orgName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.queryForm.addedWx,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryForm, "addedWx", $$v)
                      },
                      expression: "queryForm.addedWx",
                    },
                  },
                  [_vm._v("添加微信")]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-right": "10px" },
                    model: {
                      value: _vm.queryForm.dealDone,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryForm, "dealDone", $$v)
                      },
                      expression: "queryForm.dealDone",
                    },
                  },
                  [_vm._v("已开单")]
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.searchEvent()
                          },
                        },
                      },
                      [_vm._v("搜索")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { plain: "", loading: _vm.loading },
                        on: { click: _vm.reset },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "btn" },
        [
          _c(
            "div",
            [
              _c(
                "el-select",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.activeName == "2" &&
                        _vm.parArray.indexOf("oneKeyImportToWs") != -1,
                      expression:
                        "\n            activeName == '2' && parArray.indexOf('oneKeyImportToWs') != -1\n          ",
                    },
                  ],
                  attrs: { placeholder: "导入客户", clearable: "" },
                  on: { change: _vm.modeGuide },
                  model: {
                    value: _vm.guideId,
                    callback: function ($$v) {
                      _vm.guideId = $$v
                    },
                    expression: "guideId",
                  },
                },
                _vm._l(_vm.channel, function (item) {
                  return _c("el-option", {
                    key: item.dictId,
                    attrs: { label: item.dictName, value: item.dictId },
                  })
                }),
                1
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.activeName != "1" &&
                        _vm.parArray.indexOf("assignmentCode") != -1,
                      expression:
                        "activeName != '1' && parArray.indexOf('assignmentCode') != -1",
                    },
                  ],
                  staticClass: "onekey",
                  on: {
                    click: function ($event) {
                      return _vm.distribution()
                    },
                  },
                },
                [_c("span", [_vm._v("批量分配")])]
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.parArray.indexOf("jcdcCode") != -1,
                      expression: "parArray.indexOf('jcdcCode') != -1",
                    },
                  ],
                  staticClass: "onekey",
                  on: {
                    click: function ($event) {
                      return _vm.wsexport()
                    },
                  },
                },
                [_c("span", [_vm._v("导出")])]
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.activeName == "1" &&
                        _vm.parArray.indexOf("jcdcCode") != -1,
                      expression:
                        "activeName == '1' && parArray.indexOf('jcdcCode') != -1",
                    },
                  ],
                  staticClass: "onekey",
                  on: {
                    click: function ($event) {
                      return _vm.unAssign()
                    },
                  },
                },
                [_c("span", [_vm._v("取消分配")])]
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.activeName != "1" &&
                        _vm.parArray.indexOf("plfixkfCode") != -1,
                      expression:
                        "activeName != '1' && parArray.indexOf('plfixkfCode') != -1",
                    },
                  ],
                  staticClass: "onekey",
                  on: { click: _vm.plFixService },
                },
                [_c("span", [_vm._v("批改客服")])]
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.parArray.indexOf("jcDelectCode") != -1 &&
                        _vm.activeName != "1",
                      expression:
                        "parArray.indexOf('jcDelectCode') != -1 && activeName != '1'",
                    },
                  ],
                  staticClass: "onekey",
                  on: { click: _vm.deleteUsers },
                },
                [_c("span", [_vm._v("批量删除")])]
              ),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.parArray.indexOf("metastasisDepa") != -1 &&
                        _vm.activeName == "1",
                      expression:
                        "parArray.indexOf('metastasisDepa') != -1 && activeName == '1'",
                    },
                  ],
                  staticClass: "onekey",
                  on: { click: _vm.metastasis },
                },
                [_c("span", [_vm._v("转移部门共享池")])]
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.show3,
                  expression: "show3",
                },
              ],
              attrs: { size: "mini", type: "primary" },
              on: {
                click: function ($event) {
                  _vm.show3 = false
                },
              },
            },
            [_vm._v("搜索展开")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table" },
        [
          _c(
            "vxe-table",
            {
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: {
                "row-id": "id",
                data: _vm.tableData.list,
                align: "center",
              },
              on: {
                "checkbox-all": _vm.selectAllEvent,
                "checkbox-change": _vm.selectChangeEvent,
              },
            },
            [
              _vm._v(" > "),
              _c("vxe-table-column", {
                attrs: { type: "checkbox", width: "40" },
              }),
              _c("vxe-table-column", {
                attrs: { type: "seq", title: "序号", "min-width": "50" },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "batchNumber",
                  title: "批次",
                  "min-width": "50",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  field: "resourceId",
                  title: "资源ID",
                  "min-width": "80",
                },
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "资源时间",
                  "show-overflow": "",
                  "min-width": "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !_vm.is_null(scope.row.createdTime)
                          ? _c("p", [
                              _vm._v(" " + _vm._s(scope.row.createdTime) + " "),
                            ])
                          : _c("p", [_vm._v("--")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: { title: "客户姓名/电话", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "top-start",
                              width: "400",
                              trigger: "hover",
                              "open-delay": 400,
                              "close-delay": 1000,
                            },
                            on: {
                              show: function ($event) {
                                return _vm.getFeedbackLog(scope.row.id, true)
                              },
                            },
                          },
                          [
                            _c(
                              "el-table",
                              { attrs: { data: _vm.logs } },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    width: "130",
                                    property: "userName",
                                    label: "客服",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    width: "130",
                                    property: "context",
                                    label: "进度",
                                  },
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    width: "140",
                                    property: "createdTime",
                                    label: "时间",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    style: {
                                      fontWeight:
                                        scope.row.feedback &&
                                        scope.row.feedback != "{}"
                                          ? "bold"
                                          : "",
                                      color:
                                        scope.row.feedback &&
                                        scope.row.feedback != "{}"
                                          ? "#409eff"
                                          : "",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(scope.row.customerName) +
                                        " " +
                                        _vm._s(
                                          _vm.activeName == "3"
                                            ? " / " + scope.row.customerPhone
                                            : ""
                                        )
                                    ),
                                  ]
                                ),
                                _vm.activeName == "3"
                                  ? _c("p", { staticClass: "exisit" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row.reasonForFailure) +
                                          " "
                                      ),
                                    ])
                                  : _vm._e(),
                                _c(
                                  "p",
                                  {
                                    staticStyle: { cursor: "pointer" },
                                    style: {
                                      fontWeight:
                                        scope.row.feedback &&
                                        scope.row.feedback != "{}"
                                          ? "bold"
                                          : "",
                                      color:
                                        scope.row.feedback &&
                                        scope.row.feedback != "{}"
                                          ? "#409eff"
                                          : "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm
                                          .$copyText(scope.row.customerPhone)
                                          .then(
                                            function (e) {
                                              _vm.$message({
                                                type: "success",
                                                message: "成功复制手机号",
                                              })
                                            },
                                            function (e) {
                                              _vm.$message({
                                                type: "warning",
                                                message: "复制失败",
                                              })
                                            }
                                          )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.customerPhone) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "客户信息",
                  "show-overflow": "",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !_vm.is_null(scope.row.customerMessage)
                          ? _c("p", [
                              _vm._v(
                                " " + _vm._s(scope.row.customerMessage) + " "
                              ),
                            ])
                          : _c("p", [_vm._v("--")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm.salesAuthorityId != "1"
                ? _c("vxe-table-column", {
                    attrs: {
                      title: "渠道",
                      "show-overflow": "",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.sourceFrom)),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      137870669
                    ),
                  })
                : _vm._e(),
              _c("vxe-table-column", {
                attrs: { scope: "scope", title: "渠道号", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.activeName == "3"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "选择渠道",
                                      filterable: "",
                                      "default-first-option": "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeContent(scope.row)
                                      },
                                    },
                                    model: {
                                      value: scope.row.channelId,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "channelId", $$v)
                                      },
                                      expression: "scope.row.channelId",
                                    },
                                  },
                                  _vm._l(_vm.line, function (items) {
                                    return _c("el-option", {
                                      key: items.id,
                                      attrs: {
                                        label: items.name,
                                        value: items.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            )
                          : _c("p", [_vm._v(_vm._s(scope.row.channelName))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-table-column", {
                attrs: {
                  title: "分配团队",
                  prop: "assignorTeamName",
                  "min-width": "150",
                },
              }),
              _c("vxe-table-column", {
                attrs: { title: "现分配客服", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.activeName != "1"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "选择客服",
                                      filterable: "",
                                      "default-first-option": "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeContent(scope.row)
                                      },
                                    },
                                    model: {
                                      value: scope.row.assignorId,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "assignorId", $$v)
                                      },
                                      expression: "scope.row.assignorId",
                                    },
                                  },
                                  _vm._l(_vm.customer, function (items) {
                                    return _c("el-option", {
                                      key: items.id,
                                      attrs: {
                                        label: items.reallyName,
                                        value: items.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            )
                          : _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(scope.row.assignorName) +
                                  _vm._s(
                                    scope.row.customerService
                                      ? "->" + scope.row.customerService
                                      : ""
                                  ) +
                                  " "
                              ),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm.activeName == "1"
                ? _c("vxe-table-column", {
                    attrs: { title: "原分配客服", "min-width": "150" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("p", [
                                _vm._v(
                                  " " +
                                    _vm._s(scope.row.originalAssignorName) +
                                    " "
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3284355640
                    ),
                  })
                : _vm._e(),
              _vm.activeName !== "2"
                ? _c("vxe-table-column", {
                    attrs: {
                      title: "分配时间",
                      "show-overflow": "",
                      "min-width": "150",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !_vm.is_null(scope.row.updatedTime)
                                ? _c("p", [
                                    _vm._v(
                                      " " + _vm._s(scope.row.updatedTime) + " "
                                    ),
                                  ])
                                : _c("p", [_vm._v("--")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3241786543
                    ),
                  })
                : _vm._e(),
              _c("vxe-table-column", {
                attrs: { title: "操作", "min-width": "200", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.activeName != 1
                          ? _c(
                              "p",
                              { staticClass: "operation" },
                              [
                                _c("el-switch", {
                                  attrs: {
                                    "active-color": "#409EFF",
                                    "inactive-color": "#eee",
                                  },
                                  model: {
                                    value: scope.row.switchVal,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "switchVal", $$v)
                                    },
                                    expression: "scope.row.switchVal",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.activeName != "1" &&
                        _vm.parArray.indexOf("assignmentCode") != -1
                          ? _c(
                              "p",
                              {
                                staticClass: "operation",
                                on: {
                                  click: function ($event) {
                                    return _vm.distribution(
                                      scope.row,
                                      scope.$index
                                    )
                                  },
                                },
                              },
                              [_vm._v(" 分配 ")]
                            )
                          : _vm._e(),
                        _vm.parArray.indexOf("progressCode") != -1 &&
                        _vm.activeName == "1"
                          ? _c(
                              "p",
                              {
                                staticClass: "operation",
                                on: {
                                  click: function ($event) {
                                    return _vm.progressShow(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 跟进 ")]
                            )
                          : _vm._e(),
                        _vm.parArray.indexOf("jcckCode") != -1 &&
                        _vm.activeName == "1"
                          ? _c(
                              "p",
                              {
                                staticClass: "operation",
                                on: {
                                  click: function ($event) {
                                    return _vm.tosee(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 查看 ")]
                            )
                          : _vm._e(),
                        _vm.parArray.indexOf("jcckCode") != -1
                          ? _c(
                              "p",
                              {
                                staticClass: "operation",
                                on: {
                                  click: function ($event) {
                                    return _vm.copyInfo(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 复制 ")]
                            )
                          : _vm._e(),
                        _vm.activeName == "1" &&
                        _vm.parArray.indexOf("kfxq") != -1
                          ? _c(
                              "p",
                              {
                                staticClass: "operation",
                                on: {
                                  click: function ($event) {
                                    return _vm.toDetailCustomer(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 客户详情 ")]
                            )
                          : _vm._e(),
                        _vm.parArray.indexOf("jcDelectCode") != -1 &&
                        _vm.activeName != "1"
                          ? _c(
                              "p",
                              {
                                staticClass: "operation delect",
                                on: {
                                  click: function ($event) {
                                    return _vm.delectEvent(
                                      scope.row,
                                      scope.$index
                                    )
                                  },
                                },
                              },
                              [_vm._v(" 删除 ")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticStyle: { height: "40px" } }),
      _vm.tableData.totalNum >= 1
        ? _c("div", { staticClass: "page" }, [
            _c(
              "div",
              { staticClass: "block" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage1,
                    "page-sizes": [10, 20, 50, 100, 200],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.tableData.totalNum,
                    "prev-text": "上一页",
                    "next-text": "下一页",
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.progress,
            "append-to-body": true,
            title: "跟进情况",
            "before-close": _vm.progressClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.progress = $event
            },
          },
        },
        [
          _vm.lastFeedbackTime
            ? _c(
                "p",
                { staticStyle: { "margin-bottom": "15px", color: "#666" } },
                [_vm._v(" 最近更新：" + _vm._s(_vm.lastFeedbackTime) + " ")]
              )
            : _vm._e(),
          _vm.checkedForm.checked2 == 0
            ? _c("el-checkbox", {
                staticClass: "haveTo",
                attrs: { "true-label": "1", "false-label": "0", label: "接通" },
                model: {
                  value: _vm.checkedForm.checked1,
                  callback: function ($$v) {
                    _vm.$set(_vm.checkedForm, "checked1", $$v)
                  },
                  expression: "checkedForm.checked1",
                },
              })
            : _vm._e(),
          _vm.checkedForm.checked1 == 0
            ? _c("el-checkbox", {
                staticClass: "haveTo",
                attrs: {
                  "true-label": "1",
                  "false-label": "0",
                  label: "无法接通/无人接听/拒接",
                },
                model: {
                  value: _vm.checkedForm.checked2,
                  callback: function ($$v) {
                    _vm.$set(_vm.checkedForm, "checked2", $$v)
                  },
                  expression: "checkedForm.checked2",
                },
              })
            : _vm._e(),
          _c("el-checkbox", {
            staticClass: "haveTo",
            attrs: {
              "true-label": "1",
              "false-label": "0",
              label: "接通不是本人",
            },
            model: {
              value: _vm.checkedForm.checked3,
              callback: function ($$v) {
                _vm.$set(_vm.checkedForm, "checked3", $$v)
              },
              expression: "checkedForm.checked3",
            },
          }),
          _c("el-checkbox", {
            staticClass: "haveTo",
            attrs: {
              "true-label": "1",
              "false-label": "0",
              label: "空号/停机/暂停服务",
            },
            model: {
              value: _vm.checkedForm.checked13,
              callback: function ($$v) {
                _vm.$set(_vm.checkedForm, "checked13", $$v)
              },
              expression: "checkedForm.checked13",
            },
          }),
          _c("el-checkbox", {
            attrs: {
              "true-label": "1",
              "false-label": "0",
              label: "电话沟通完添加微信",
            },
            model: {
              value: _vm.checkedForm.checked4,
              callback: function ($$v) {
                _vm.$set(_vm.checkedForm, "checked4", $$v)
              },
              expression: "checkedForm.checked4",
            },
          }),
          _c("el-checkbox", {
            attrs: {
              "true-label": "1",
              "false-label": "0",
              label: "直接搜索手机号添加",
            },
            model: {
              value: _vm.checkedForm.checked5,
              callback: function ($$v) {
                _vm.$set(_vm.checkedForm, "checked5", $$v)
              },
              expression: "checkedForm.checked5",
            },
          }),
          _c("el-checkbox", {
            attrs: {
              "true-label": "1",
              "false-label": "0",
              label: "有意向/正常走流程",
            },
            model: {
              value: _vm.checkedForm.checked6,
              callback: function ($$v) {
                _vm.$set(_vm.checkedForm, "checked6", $$v)
              },
              expression: "checkedForm.checked6",
            },
          }),
          _c("el-checkbox", {
            attrs: {
              "true-label": "1",
              "false-label": "0",
              label: "添加完不说话",
            },
            model: {
              value: _vm.checkedForm.checked7,
              callback: function ($$v) {
                _vm.$set(_vm.checkedForm, "checked7", $$v)
              },
              expression: "checkedForm.checked7",
            },
          }),
          _c("el-checkbox", {
            attrs: {
              "true-label": "1",
              "false-label": "0",
              label: "添加完拉黑",
            },
            model: {
              value: _vm.checkedForm.checked8,
              callback: function ($$v) {
                _vm.$set(_vm.checkedForm, "checked8", $$v)
              },
              expression: "checkedForm.checked8",
            },
          }),
          _c("el-checkbox", {
            attrs: {
              "true-label": "1",
              "false-label": "0",
              label: "二十岁以下",
            },
            model: {
              value: _vm.checkedForm.checked9,
              callback: function ($$v) {
                _vm.$set(_vm.checkedForm, "checked9", $$v)
              },
              expression: "checkedForm.checked9",
            },
          }),
          _c("br"),
          _c("el-checkbox", {
            attrs: { "true-label": "1", "false-label": "0", label: "秒杀" },
            model: {
              value: _vm.checkedForm.checked10,
              callback: function ($$v) {
                _vm.$set(_vm.checkedForm, "checked10", $$v)
              },
              expression: "checkedForm.checked10",
            },
          }),
          _c(
            "div",
            { staticClass: "checkbox" },
            [
              _c("el-input", {
                attrs: {
                  type: "number",
                  placeholder: "请输入秒杀金额",
                  size: "mini",
                },
                model: {
                  value: _vm.checkedForm.checked11,
                  callback: function ($$v) {
                    _vm.$set(_vm.checkedForm, "checked11", $$v)
                  },
                  expression: "checkedForm.checked11",
                },
              }),
              _c("span", [_vm._v("秒杀金额")]),
            ],
            1
          ),
          _c("el-divider"),
          _c(
            "div",
            { staticClass: "checkbox haveTo" },
            [
              _c("span", [_vm._v("是否接通")]),
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.checkedForm.isConnect,
                    callback: function ($$v) {
                      _vm.$set(_vm.checkedForm, "isConnect", $$v)
                    },
                    expression: "checkedForm.isConnect",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: "get_through" } }, [
                    _vm._v("接通"),
                  ]),
                  _c("el-radio", { attrs: { label: "block_call" } }, [
                    _vm._v("未接通"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.checkedForm.isConnect == "block_call"
            ? _c(
                "div",
                { staticClass: "checkbox haveTo" },
                [
                  _c("span", [_vm._v("未接通情况")]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择未接通情况",
                        size: "mini",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.checkedForm.connectedNotA,
                        callback: function ($$v) {
                          _vm.$set(_vm.checkedForm, "connectedNotA", $$v)
                        },
                        expression: "checkedForm.connectedNotA",
                      },
                    },
                    _vm._l(_vm.dictionaries.block_call, function (item) {
                      return _c("el-option", {
                        key: item.dictId,
                        attrs: { label: item.dictName, value: item.dictId },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.checkedForm.isConnect == "get_through"
            ? _c(
                "div",
                { staticClass: "checkbox haveTo" },
                [
                  _c("span", [_vm._v("接通情况")]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择接通情况",
                        size: "mini",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.checkedForm.connectedNotB,
                        callback: function ($$v) {
                          _vm.$set(_vm.checkedForm, "connectedNotB", $$v)
                        },
                        expression: "checkedForm.connectedNotB",
                      },
                    },
                    _vm._l(_vm.dictionaries.get_through, function (item) {
                      return _c("el-option", {
                        key: item.dictId,
                        attrs: { label: item.dictName, value: item.dictId },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("el-divider"),
          _c(
            "div",
            { staticClass: "checkbox" },
            [
              _c("span", [_vm._v("备注")]),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  autosize: "",
                  placeholder: "请输入备注",
                  size: "mini",
                },
                model: {
                  value: _vm.checkedForm.checked12,
                  callback: function ($$v) {
                    _vm.$set(_vm.checkedForm, "checked12", $$v)
                  },
                  expression: "checkedForm.checked12",
                },
              }),
            ],
            1
          ),
          _c("el-divider"),
          _c(
            "div",
            [
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.logs, "max-height": "250" },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { prop: "userName", label: "客服", width: "100" },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "context", label: "进度", width: "300" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "qualityLabelName",
                        label: "接听状态",
                        width: "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "connectedNotName",
                        label: "资源反馈",
                        width: "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "createdTime", label: "时间" },
                    }),
                  ],
                  1
                ),
              ],
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.progreeSubmit()
                    },
                  },
                },
                [_vm._v("确定")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.progress = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.leadingInLive,
            "append-to-body": true,
            title: "订单导入",
          },
          on: {
            "update:visible": function ($event) {
              _vm.leadingInLive = $event
            },
            close: _vm.handleDialogClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "popIn" },
            [
              _c(
                "el-upload",
                {
                  ref: "tops",
                  staticClass: "upload-demo",
                  attrs: {
                    accept: ".doc,.docx,.xls,.xlsx,.csv",
                    drag: "",
                    action: "#",
                    multiple: false,
                    "http-request": _vm.orderImportLive,
                    limit: 1,
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-upload" }),
                  _c("div", { staticClass: "el-upload__text" }, [
                    _vm._v("将文件拖到此处，或"),
                    _c("em", [_vm._v("点击上传")]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.keyvalue == "comm"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.templateMode()
                          _vm.guideId = ""
                          _vm.$refs.tops.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.keyvalue == "OPPO"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.opopImport()
                          _vm.guideId = ""
                          _vm.$refs.tops.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.keyvalue == "BaiDu"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.baiduImport()
                          _vm.guideId = ""
                          _vm.$refs.tops.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.keyvalue == "RestAssured"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.safeImport()
                          _vm.guideId = ""
                          _vm.$refs.tops.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.keyvalue == "Phoenix"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.phoneixImport()
                          _vm.guideId = ""
                          _vm.$refs.tops.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.keyvalue == "GuangDianTong"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.broadpointImport()
                          _vm.guideId = ""
                          _vm.$refs.tops.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.keyvalue == "uc"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.uCImport()
                          _vm.guideId = ""
                          _vm.$refs.tops.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.keyvalue == "head"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.headlinesImport()
                          _vm.guideId = ""
                          _vm.$refs.tops.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.keyvalue == "aqy"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.headlinesAiqiyi()
                          _vm.guideId = ""
                          _vm.$refs.tops.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _vm.keyvalue == "ks"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.leadingInLive = false
                          _vm.kwaiFu()
                          _vm.$refs.tops.clearFiles()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.leadingInLive = false
                      _vm.guideId = ""
                      _vm.$refs.tops.clearFiles()
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.kfShow,
            "append-to-body": true,
            title: "批量修改分配客服",
            "before-close": _vm.serviceClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.kfShow = $event
            },
          },
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "客服" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "elselect",
                      staticStyle: { width: "90%" },
                      attrs: {
                        filterable: "",
                        "default-first-option": "",
                        placeholder: "请选择分配客服",
                        size: "small",
                        multiple: "",
                      },
                      model: {
                        value: _vm.moreService,
                        callback: function ($$v) {
                          _vm.moreService = $$v
                        },
                        expression: "moreService",
                      },
                    },
                    _vm._l(_vm.customer, function (items) {
                      return _c("el-option", {
                        key: items.id,
                        attrs: { label: items.reallyName, value: items.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.moreGuideCustomer()
                    },
                  },
                },
                [_vm._v("确定")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.kfShow = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }